import HeaderComponent from "../Components/HeaderComponent";
import FooterTopComponent from "../Components/FooterTopComponent";
import FooterBottomComponent from "../Components/FooterBottomComponent";
import React from "react";
import config from "../config";

export default function TermsPage() {
    return (
        <main>
            <HeaderComponent/>
            <h1>{config.pages.terms.title}</h1>

            <FooterTopComponent />
            <FooterBottomComponent />
        </main>
    );
}
